import React from 'react';

const HomePageGreetingCardAdvert = () => {
    return (
        <section className="container greeting-card-advert">
            <h2>Greetings Cards</h2>
            <p className="text-center">Selected artwork is also available as greetings cards. Please contact me for more details.</p>
        </section>
    );
};

export default HomePageGreetingCardAdvert;



// WEBPACK FOOTER //
// ./src/components/homePage/HomePageGreetingCardAdvert.js